import * as moment from 'moment';

export function getDaysBetween(startDate: Date, endDate: Date): number {
    return moment(endDate).diff(startDate, 'days');
}

export function getDateId(date: Date): string {
    return [date.getFullYear(), date.getMonth(), date.getDate()].join('-')
}


// WEBPACK FOOTER //
// ./src/components/widget/util/DateUtil.ts